// extracted by mini-css-extract-plugin
module.exports = {"products":"TO","oosMessaging":"UO"};